
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire18e5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire18e5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ea1L4", function(module, exports) {

$parcel$export(module.exports, "RANKS", () => $a4f35d071b9bafc6$export$3086cf0ed78ec79c);
$parcel$export(module.exports, "ladder", () => $a4f35d071b9bafc6$export$41b34c9c633628d8);
$parcel$export(module.exports, "article", () => $a4f35d071b9bafc6$export$bba2aacf8566461b);
$parcel$export(module.exports, "default", () => $a4f35d071b9bafc6$export$2e2bcd8739ae039);
// The rank ladder, derived from the user document and stored nowhere.
//
// There is no rank field and there must not be one. Everything below is
// computed from fields that already exist on every live document, so there is
// no migration, no new Firestore rule, and nothing that can drift out of step
// with the progress bar. (The September 2026 backfill touched
// unansweredQnsIDs and totalQnsInMainCollection, which predate the ladder — it
// added no field for it, and none should ever be added.)
//
// totalCorrect and not totalAttempts. A question leaves the pool only when
// answered correctly, so every correct answer is a distinct question gone for
// good and the count cannot be farmed. Attempts can be: four options, a guess,
// a click. A timeout writes nothing at all, so an attempts ladder would also
// have rewarded clicking and ignored the player who read the question and ran
// out of time.
//
// Below the first rung there is NO name. Callers must render next/toGo there
// and must not invent a label for what the player is not yet — "Yodha, 20 to
// go", never "Novice". Naming the goal pulls; naming the shortfall does not.
//
// Ardharatha is deliberately absent. It is Bhishma's public humiliation of
// Karna in the Udyoga Parva. A player who does not know the term gains nothing
// from it, and a player who does know it is the best player on the site, being
// handed a slur as a reward.
//
// ATIRATHA OUTRANKS MAHARATHA. The order below is correct. Do not "fix" it.
//
// This will look wrong to you, because almost everything written about the
// classification says the reverse. A web search returns Ardharatha -> Rathi ->
// Atirathi -> Maharathi, with Maharathi at the top taking on 720,000, and calls
// Bhishma a maharatha. An LLM asked cold will tell you the same, because that
// is what it read. All of it is popular tradition, and CLAUDE.md already says
// the Critical Edition wins where the two disagree.
//
// Debroy, translating the CE, is unambiguous, in four separate footnotes:
//
//   "An atiratha is an unrivalled warrior, whose valour is unlimited, greater
//    than a maharatha."
//   "A maharatha is a warrior who can take on 10,000 warriors single-handed.
//    An atiratha can take on 60,000."
//   "An atiratha is a great warrior, superior to a maharatha."
//   "Bhishma was an atiratha."
//
// So the popular version has the order backwards, the numbers wrong, and
// Bhishma in the wrong tier. The landing page glosses Atiratha as "unrivalled
// warrior" on the strength of the first quotation.
//
// Reordering RANKS is also not the cheap edit it looks like, which is worth
// knowing before anyone tries it on a hunch. Rank is computed, never stored,
// so a swap silently renames what every live player is called. rankBadge.js
// keys the wheel off the NAME, so the eighteen-spoke wheel that matches the
// certificate would have to be moved to whichever rung ended up last. And the
// GA4 `rank` dimension already holds months of data under these names;
// registration is not retroactive and a parameter cannot be re-registered.
//
// KEEP THIS FILE IMPORT-FREE. tests/rank.test.mjs loads it directly in Node,
// which does not resolve the extensionless imports the rest of the app uses.
//
// No .at(-1) or .findLast() anywhere below. There is no browserslist in
// package.json, so Parcel picks its own default targets, and those two are
// Safari 15.4 — newer than the ?. and ?? this codebase already relies on.
// Indexing costs nothing and removes the question.
//
// `spokes` lives here rather than in rankBadge.js so the ladder has one home.
// It is the count on the badge's wheel, rising to the eighteen the certificate
// carries. See rankBadge.js.
//
// 6, not 4, at the bottom. Four spokes at a legible stroke weight draw a plus
// sign through the disc and the badge reads as a crosshair rather than a wheel
// — checked by rendering it. Six is the fewest that still reads as a wheel.
// The steps are then even, four apart, which is the most spoke density can
// carry at the 24px the header uses.
// THE LAST RUNG STILL HAS NO FIXED NUMBER, and it still must not get one.
//
// initializeUser copies questionsIDsArr into the player's own unansweredQnsIDs
// once, at first sign-in, and never re-reads it. So "the whole quiz" is a size
// each player carries themselves, and ladder() resolves this rung to it.
//
// That used to mean the pools drifted apart permanently: on 11 September 2026,
// 592 of 595 live documents were frozen at 973 while the master list held 1000,
// so a rung hardcoded at 1000 would have been unreachable for every one of them
// and the profile line would have read "27 more to Atiratha" forever.
//
// THAT HAS BEEN REPAIRED, and the repair is why the number stays out of here
// rather than a reason to put it in:
//
//   - backfill-user-pools.mjs ran against production on 11 September 2026 and
//     brought 565 players up to the full 1000. 567 documents now read 1000.
//   - upload-new-questions.mjs deals every newly added question into every
//     unfinished pool as phase two of the upload, so the gap cannot reopen.
//
// So today almost everyone is on the same number — but "almost" is the whole
// point. 28 documents are deliberately NOT: 23 certificate holders and 4
// players who finished without claiming stay at 973 forever, because topping
// them up would take away a certificate they have earned, and one malformed
// document has no pool at all. Hardcode 1000 here and ladder() puts the last
// rung above the pool those 27 can actually finish, so rank() would never call
// them Atiratha again.
//
// It is also the same reason the certificate and the end-of-quiz panel say
// "every question" rather than a number. The landing page is the one place that
// prints 1000, and the comment on that <li> in index.html carries the argument
// for it and its cost.
const $a4f35d071b9bafc6$export$3086cf0ed78ec79c = [
    {
        name: "Yodha",
        at: 25,
        spokes: 6
    },
    {
        name: "Ratha",
        at: 100,
        spokes: 10
    },
    {
        name: "Maharatha",
        at: 300,
        spokes: 14
    },
    {
        name: "Atiratha",
        at: null,
        spokes: 18
    } // resolved per player by ladder()
];
// Only for a document with no totalQnsInMainCollection at all. getUserProfilePanel
// re-reads the live list in that case; here it is a last resort, not a promise.
const $a4f35d071b9bafc6$var$FALLBACK_WHOLE = 1000;
function $a4f35d071b9bafc6$export$41b34c9c633628d8(totalQuestions) {
    const n = Number(totalQuestions);
    const whole = Number.isFinite(n) && n > 0 ? Math.floor(n) : $a4f35d071b9bafc6$var$FALLBACK_WHOLE;
    const rungs = $a4f35d071b9bafc6$export$3086cf0ed78ec79c.filter((r)=>r.at !== null && r.at < whole);
    rungs.push({
        ...$a4f35d071b9bafc6$export$3086cf0ed78ec79c[$a4f35d071b9bafc6$export$3086cf0ed78ec79c.length - 1],
        at: whole
    });
    return rungs;
}
function $a4f35d071b9bafc6$export$bba2aacf8566461b(name) {
    return /^[aeiou]/i.test(name) ? "an" : "a";
}
function $a4f35d071b9bafc6$export$2e2bcd8739ae039(userDocument) {
    const doc = userDocument ?? {};
    const rungs = $a4f35d071b9bafc6$export$41b34c9c633628d8(doc.totalQnsInMainCollection);
    const last = rungs[rungs.length - 1];
    // An EMPTY POOL is the only trustworthy completion signal, and it outranks
    // the count. Verified in production: finishers sit at 970, 971, 972 and 973
    // correct against a pool of 973, all with unansweredQnsIDs empty and a
    // certificate issued. firebaseSetDocWrapper neither awaits nor catches
    // (known issue 3), so an increment can be dropped while the arrayRemove in
    // the same write lands — the count drifts below the truth and never
    // recovers.
    //
    // Going by the count would have told eleven of the twenty-two people who
    // have finished this quiz that they are a Maharatha with two more to go.
    //
    // It is also the same test showLoggedInView and loadQuizRound already use to
    // decide the quiz is over, so the panels agree by construction.
    const n = Number(doc.totalCorrect) || 0;
    const finished = Array.isArray(doc.unansweredQnsIDs) && doc.unansweredQnsIDs.length === 0;
    // n > 0 guards a document caught mid-initialisation, where the pool has not
    // been written yet. Nobody finishes with nothing correct.
    if (finished && n > 0) return {
        name: last.name,
        attained: last,
        next: null,
        toGo: 0
    };
    let attained = null;
    let next = null;
    for (const r of rungs){
        if (n >= r.at) attained = r;
        else if (!next) next = r;
    }
    return {
        name: attained ? attained.name : null,
        attained: attained,
        next: next,
        toGo: next ? next.at - n : 0
    };
}

});

parcelRegister("gVCw1", function(module, exports) {

$parcel$export(module.exports, "default", () => $c52fd893ea92f1fe$export$2e2bcd8739ae039);
$parcel$export(module.exports, "applyRankBadge", () => $c52fd893ea92f1fe$export$f166e0e435f73f40);
// The rank badge: the certificate's own chariot wheel, arriving a quarter at a
// time.
//
// drawCertificate.js draws one wheel, breaking the ember frame at top centre —
// a sand disc, an orangered ring, a thin ochre ring inside it, eighteen spokes,
// an orangered hub with a sand eye. Eighteen for the parvas, the akshauhinis
// and the days of the war. Nothing on the certificate explains that, and
// nothing here does either.
//
// So the badge is not a separate trophy set. It is that wheel, incomplete: six
// spokes at Yodha, ten at Ratha, fourteen at Maharatha, and at Atiratha the
// certificate's wheel exactly — eighteen spokes, both rings, the sand eye. A
// player who earns the last one has already seen it, at the top of the page
// they are about to be given.
//
// Keyed by NAME, not by threshold: ladder() resolves the last rung to each
// player's own pool size, so the number is not the same for two players and
// cannot identify a badge.
//
// Inline SVG rather than four images. No asset pipeline, one function serves
// the 24px header and the 64px reveal, and the paint is var(--sand) and
// var(--accent) rather than a copy of them, so it cannot drift from the site.
// Rasterising it would also have meant Parcel content-hashing four new files.
//
// GEOMETRY is drawWheel()'s, scaled by 18/70 into a 36x36 box, so the two stay
// recognisably the same object. Two deliberate departures, both for the 24px
// case, where a faithful scale is invisible:
//
//   - Spokes are 0.9 wide, not the faithful 0.51. At 24px, 0.51 renders as a
//     third of a pixel and vanishes into the ground.
//   - The ochre ring is 0.5 wide, not 0.26, for the same reason.
//
// SVG's y axis runs down and pdf-lib's runs up, so the spoke loop subtracts
// where drawWheel adds. The wheel is symmetric, so this is invisible — it is
// written this way to stay diffable against the original.
// With the extension, unlike the rest of the app. Parcel resolves either, but
// Node resolves only this form, and scripts/dev/render-badges.mjs loads this
// file directly to draw the contact sheet. Same reason drawCertificate.js can
// render in Node.

var $ea1L4 = parcelRequire("ea1L4");
// Ochre is not a CSS custom property: drawCertificate.js hardcodes it, and the
// file's header says the palette comes from resets.css "plus a gilt sampled
// from the hero". Rather than add a token for one ring, this keeps the pair
// together the way the certificate does. Change one, change the other.
const $c52fd893ea92f1fe$var$OCHRE = "#8a6116";
const $c52fd893ea92f1fe$var$C = 18; // centre
const $c52fd893ea92f1fe$var$R_DISC = 18;
const $c52fd893ea92f1fe$var$R_RING = 15.9; // orangered, the outer rule
const $c52fd893ea92f1fe$var$R_INNER = 13.4; // ochre, the thin rule; also where spokes end
const $c52fd893ea92f1fe$var$R_HUB_OUT = 3.1;
const $c52fd893ea92f1fe$var$R_SPOKE_IN = 3.3;
const $c52fd893ea92f1fe$var$R_EYE = 1.03;
function $c52fd893ea92f1fe$var$spokePath(spokes) {
    let d = "";
    for(let i = 0; i < spokes; i++){
        const a = (90 + i * 360 / spokes) * Math.PI / 180;
        const cos = Math.cos(a);
        const sin = Math.sin(a);
        d += `M ${($c52fd893ea92f1fe$var$C + $c52fd893ea92f1fe$var$R_SPOKE_IN * cos).toFixed(2)} ${($c52fd893ea92f1fe$var$C - $c52fd893ea92f1fe$var$R_SPOKE_IN * sin).toFixed(2)} ` + `L ${($c52fd893ea92f1fe$var$C + $c52fd893ea92f1fe$var$R_INNER * cos).toFixed(2)} ${($c52fd893ea92f1fe$var$C - $c52fd893ea92f1fe$var$R_INNER * sin).toFixed(2)} `;
    }
    return d.trim();
}
function $c52fd893ea92f1fe$export$2e2bcd8739ae039(name, size = 24) {
    const r = (0, $ea1L4.RANKS).find((x)=>x.name === name);
    if (!r) return "";
    // By POSITION, not by threshold. The last rung's `at` is null in RANKS —
    // ladder() resolves it per player — so any comparison against it is false and
    // Atiratha would silently lose its inner rule and its eye.
    const i = (0, $ea1L4.RANKS).indexOf(r);
    const isFirst = i === 0;
    const isLast = i === (0, $ea1L4.RANKS).length - 1;
    return `<svg width="${size}" height="${size}" viewBox="0 0 36 36" ` + `aria-hidden="true" focusable="false" class="rank-badge-svg">` + `<circle cx="${$c52fd893ea92f1fe$var$C}" cy="${$c52fd893ea92f1fe$var$C}" r="${$c52fd893ea92f1fe$var$R_DISC}" fill="var(--sand)"/>` + `<circle cx="${$c52fd893ea92f1fe$var$C}" cy="${$c52fd893ea92f1fe$var$C}" r="${$c52fd893ea92f1fe$var$R_RING}" fill="none" ` + `stroke="var(--accent)" stroke-width="1.29"/>` + // The inner rule arrives at Ratha. Yodha is the bare wheel.
    //
    // KEEP THIS ON ONE LINE. It is 106 characters in a file wrapped at 80,
    // and re-wrapping it across a `+` silently reintroduces a production bug.
    // There is no linter and no formatter in this repo to stop you.
    //
    // Until September 2026 it was split as `...r="${R_INNER}" fill="none" ` +
    // `stroke="${OCHRE}"...`. Every interpolation in that expression is a
    // module constant, so SWC folded the concatenation to a plain string —
    // and folding it DROPPED ` fill="none" `, emitting r="13.4stroke=" into
    // the bundle. An invalid r means the circle is never drawn, so the ochre
    // rule was missing from Ratha, Maharatha and Atiratha in production, at
    // 0.5px in a 24px header, for as long as the badges have existed.
    //
    // The trigger is CONSTANT FOLDING, not the `+` on its own. The other
    // split concatenations in this function survive because their chains keep
    // a runtime interpolation — ${size}, ${spokePath(...)} — so SWC never
    // folds them. Do not "fix" those; they are fine as they are.
    //
    // render-badges.mjs cannot catch this class of bug. It imports this file
    // directly, so it draws the source and never the bundle. Only reading the
    // built output, or the page itself, will show it.
    (isFirst ? "" : `<circle cx="${$c52fd893ea92f1fe$var$C}" cy="${$c52fd893ea92f1fe$var$C}" r="${$c52fd893ea92f1fe$var$R_INNER}" fill="none" stroke="${$c52fd893ea92f1fe$var$OCHRE}" stroke-width="0.5"/>`) + // fill="none" is not optional. Each spoke is an open M/L subpath, and SVG
    // fills an open subpath as if closed — these are degenerate today, so the
    // default black fill happens to paint nothing, but that is luck rather than
    // intent and would stop being true the moment a spoke gains a third point.
    `<path d="${$c52fd893ea92f1fe$var$spokePath(r.spokes)}" fill="none" stroke="var(--accent)" ` + `stroke-width="0.9" stroke-linecap="butt"/>` + `<circle cx="${$c52fd893ea92f1fe$var$C}" cy="${$c52fd893ea92f1fe$var$C}" r="${$c52fd893ea92f1fe$var$R_HUB_OUT}" fill="var(--accent)"/>` + // The sand eye is the last thing to arrive, and it is what makes Atiratha
    // the certificate's wheel rather than a denser version of Maharatha's.
    (isLast ? `<circle cx="${$c52fd893ea92f1fe$var$C}" cy="${$c52fd893ea92f1fe$var$C}" r="${$c52fd893ea92f1fe$var$R_EYE}" fill="var(--sand)"/>` : "") + `</svg>`;
}
function $c52fd893ea92f1fe$export$f166e0e435f73f40(userNameElem, name) {
    if (!userNameElem) return;
    const existing = userNameElem.querySelector(".rank-badge");
    // rankBadge returns "" for any name that is not a rung, so this both handles
    // "no rank yet" and proves `name` came from RANKS. That matters because the
    // line below interpolates it into innerHTML: this function is exported, and
    // the next caller might reach for a display name or a certificate's issuedTo,
    // both of which are free text a user typed. Validating here means they
    // cannot, rather than meaning they must not.
    const svg = $c52fd893ea92f1fe$export$2e2bcd8739ae039(name);
    if (!svg) {
        if (existing) existing.remove();
        return;
    }
    if (existing && existing.title === name) return;
    const badge = existing ?? document.createElement("span");
    badge.className = "rank-badge";
    badge.title = name;
    badge.innerHTML = svg + `<span class="visually-hidden">Rank: ${name}. </span>`;
    if (!existing) userNameElem.prepend(badge);
}

});

parcelRegister("3mebY", function(module, exports) {

$parcel$export(module.exports, "default", () => $271e6f68f748b5c5$export$2e2bcd8739ae039);
// Shows a dismissible "install this app" banner on mobile.
//
// Android/Chrome fires beforeinstallprompt and gives us a real prompt() call.
// iOS Safari has no such API at all, so it gets a text hint instead.

var $b0m9P = parcelRequire("b0m9P");
const $271e6f68f748b5c5$var$DISMISSED_KEY = "tgmq.installDismissed";
// The banner's colours now come from .install-banner in resets.css, which uses
// --accent-deep (#C43C00) for exactly the reason this constant used to exist:
// the brand orangered (#FF4500) is only 3.4:1 against white, under the 4.5:1 AA
// minimum for text this size, while #C43C00 is 5.3:1. Do not swap the class for
// --accent.
// Safari with cookies blocked throws SecurityError on any localStorage access,
// and Private Browsing throws on write. This banner is cosmetic; an unguarded
// throw here would propagate out of the entry module and leave the quiz page
// with no sign-in button and no auth observer.
function $271e6f68f748b5c5$var$wasDismissed() {
    try {
        return !!localStorage.getItem($271e6f68f748b5c5$var$DISMISSED_KEY);
    } catch  {
        return false;
    }
}
function $271e6f68f748b5c5$var$rememberDismissal() {
    try {
        localStorage.setItem($271e6f68f748b5c5$var$DISMISSED_KEY, "1");
    } catch  {
    // Private mode. The banner simply comes back on the next load.
    }
}
function $271e6f68f748b5c5$var$isIOS() {
    const ua = window.navigator.userAgent;
    // iPadOS 13+ reports a Macintosh user agent. maxTouchPoints separates a real
    // iPad from a desktop Mac.
    return /iphone|ipad|ipod/i.test(ua) || /macintosh/i.test(ua) && window.navigator.maxTouchPoints > 1;
}
function $271e6f68f748b5c5$var$showBanner(text, actionLabel, onAction) {
    // beforeinstallprompt can fire more than once per page load, after the
    // startup checks have already run, so both are re-checked here.
    if (document.getElementById("installBanner")) return;
    if ($271e6f68f748b5c5$var$wasDismissed()) return;
    const banner = document.createElement("div");
    banner.id = "installBanner";
    // Normal flow at the top of the page, matching getOfflineMessage. A fixed
    // bottom bar would sit over whatever the page ends with — on play.html the
    // fourth option, or the Claim Your Certificate button. play.css makes body
    // the flex container precisely so this banner is a flex sibling: it takes its
    // own height and #flex-container gives that height up, rather than the banner
    // pushing a full-viewport box down past the bottom of the screen.
    banner.className = "install-banner";
    function removeBanner() {
        banner.remove();
    }
    const msg = document.createElement("span");
    msg.textContent = text;
    // .install-banner-msg states its own colour rather than inheriting. index.css
    // used to carry a bare `span` rule, which beat the banner's own colour and
    // painted this text orangered on orangered.
    msg.className = "install-banner-msg";
    banner.appendChild(msg);
    if (actionLabel) {
        const actionBtn = document.createElement("button");
        actionBtn.textContent = actionLabel;
        actionBtn.className = "install-banner-action";
        actionBtn.addEventListener("click", ()=>{
            removeBanner();
            onAction();
        });
        banner.appendChild(actionBtn);
    }
    const dismissBtn = document.createElement("button");
    dismissBtn.setAttribute("aria-label", "Dismiss");
    dismissBtn.textContent = "\xd7";
    dismissBtn.className = "install-banner-dismiss";
    dismissBtn.addEventListener("click", ()=>{
        removeBanner();
        $271e6f68f748b5c5$var$rememberDismissal();
    });
    banner.appendChild(dismissBtn);
    document.body.insertBefore(banner, document.body.firstChild);
}
function $271e6f68f748b5c5$export$2e2bcd8739ae039() {
    // Desktop, already installed, or already dismissed: nothing to do.
    if (!window.matchMedia("(pointer: coarse)").matches) return;
    if ((0, $b0m9P.default)()) return;
    if ($271e6f68f748b5c5$var$wasDismissed()) return;
    if ($271e6f68f748b5c5$var$isIOS()) {
        $271e6f68f748b5c5$var$showBanner("Install the quiz: tap Share, then Add to Home Screen.");
        return;
    }
    window.addEventListener("beforeinstallprompt", (event)=>{
        event.preventDefault();
        // showBanner removes the banner before running this, so prompt() is called
        // with the banner already gone.
        $271e6f68f748b5c5$var$showBanner("Add the quiz to your home screen.", "Install", ()=>// Chrome rejects prompt() if it has already been used or the gesture
            // expired. The banner is gone by now and Chrome will not re-fire
            // beforeinstallprompt for this load, so there is nothing to recover to —
            // but an unhandled rejection helps no one.
            event.prompt().catch((error)=>void 0));
    });
}

});


//# sourceMappingURL=play.091cc1e7.js.map
